import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SharedService } from '../../services/shared.service';
import { PriceChannel } from '../../model/price-channel.model';
import { RoutingService } from '@spartacus/core';

@Component({
    selector: 'channel-select',
    templateUrl: './channel-select.component.html',
    standalone: false
})
export class ChannelSelectComponent {
  @Input() selectChannelSource: string;
  @Input() userId: string;
  @Output() channelSourceEvent = new EventEmitter<string>();
  protected readonly PriceChannel = PriceChannel;
  selectedChannel: string = sessionStorage.getItem('selectedChannel');
  resetContract: boolean = false;

  constructor(protected readonly modal: NgbModal, private readonly sharedService: SharedService, private router: RoutingService) {}
  //TODO thing in the future if we should use form instead of accessing inputs values directly
  selectChannel(event: Event): void {
    // @ts-ignore
    const inputValue = event.target.value as PriceChannel;
    this.selectedChannel = inputValue;
    const channel = sessionStorage.getItem('selectedChannel');

    if (channel !== inputValue) {
      this.resetContract = true;

      return;
    }

    this.resetContract = false;
  }

  submit(): void {
    if (this.resetContract) {
      sessionStorage.removeItem('contractFromCartApi');
      sessionStorage.removeItem('contractFromCartApiName');
    }

    this.sharedService.postPriceChannel(localStorage.getItem('user_login_id'), this.selectedChannel);
    sessionStorage.setItem('selectedChannel', this.selectedChannel);

    setTimeout(() => {
      if (this.selectChannelSource && this.selectChannelSource === 'account') {
        this.channelSourceEvent.emit(this.selectChannelSource);
      } else {
        this.router.goByUrl('my-account/account-overview').then(()=> window.location.reload());
      }
    }, 500);
  }
}
